import React, { useEffect } from "react";
import Card from "@mui/material/Card";
import { CardHeader, Avatar, Divider } from "@mui/material";
import Typography from "@mui/material/Typography";
import CardContent from "@mui/material/CardContent";
import { getProcessIconByProcessingState } from "../../../components/ProcessIndicator/getProcessIconByProcessingState";
import { fetchAssigneesByEstateThunk } from "../../../modules/ticket/ticketDetail/assigneeList/assigneeListOperations";
import TicketAssignDialogButton from "./components/TicketAssignDialogButton";
import { ROLES } from "../../../modules/accounts/accountConstants";
import { accountSelectors } from "../../../modules/accounts/accountSlice";
import { accountHasRole } from "../../../modules/accounts/accountFunctions";
import { assigneeListSelectors } from "../../../modules/ticket/ticketDetail/assigneeList/assigneeListSlice";
import AttachmentList from "../../../components/AttachmentList/AttachmentList";
import DocumentLayout from "../../../components/Layouts/DocumentLayout";
import MessagesSection from "./MessagesSection";
import { getCardHeader } from "./ticketDetailUtils";
import { useDispatch, useSelector } from "react-redux";

// Whether the ticket has a direct (own) property
const ticketHasProperty = (ticket = {}, field) =>
  Object.prototype.hasOwnProperty.call(ticket, field);

// Access a field off serviceType (e.g. name)
const getTicketServiceType = (ticket = {}, field) =>
  ticket?.serviceType ? ticket.serviceType[field] : undefined;

const ServiceType = (props) => (
  <Typography component="p">
    <strong>{props.item.serviceType}</strong>
  </Typography>
);

const TicketDescription = ({ item }) => {
  const descriptionArray = item.body ? item.body.split(/\n/) : [];
  const descriptionRows = descriptionArray.map((row, index) => {
    return (
      <div key={index} style={{ minHeight: "19px" }}>
        {row.split()}
      </div>
    );
  });

  return <div>{descriptionRows}</div>;
};

const TicketDetailItemPublic = React.memo(function MessageDetailItemPublic({
  item,
}) {
  const dispatch = useDispatch();
  const currentAccount = useSelector(accountSelectors.selectCurrentAccount);
  const userIsTicketManager = accountHasRole(
    currentAccount,
    ROLES.TICKET_MANAGER,
  );
  const assignees = useSelector((state) =>
    assigneeListSelectors.selectByIds(state, item.assigneeIds),
  );

  useEffect(() => {
    if (item && item.estateId) {
      dispatch(fetchAssigneesByEstateThunk(item.estateId));
    }
  }, [item, dispatch]);

  const attachments = item.attachments || [];
  const cardHeader = getCardHeader(item, attachments);
  const ticketManagers = assignees.filter((assignee) =>
    assignee.relations.includes(ROLES.TICKET_MANAGER),
  );

  return (
    <DocumentLayout>
      <Card>
        <CardHeader
          title={cardHeader.title}
          subheader={cardHeader.subheader}
          action={
            <div style={{ display: "flex" }}>
              {ticketManagers.map((manager) => (
                <Avatar key={manager.id}>
                  {manager.initials.toUpperCase()}
                </Avatar>
              ))}
              <Avatar
                style={{
                  backgroundColor: "whitesmoke",
                  marginLeft: "-0.25rem",
                }}
              >
                {getProcessIconByProcessingState(item.processingState)}
              </Avatar>
            </div>
          }
        />

        {/* attachments section */}
        {attachments && attachments.length > 0 && (
          <>
            <Divider />
            <AttachmentList attachments={attachments} />
          </>
        )}

        {ticketHasProperty(item, "serviceType") && (
          <>
            <Divider />
            <CardContent>
              <div>
                <ServiceType
                  item={{ serviceType: getTicketServiceType(item, "name") }}
                />
              </div>
            </CardContent>
          </>
        )}

        <CardContent>
          <TicketDescription item={item} />
        </CardContent>

        {userIsTicketManager && (
          <CardContent>
            <TicketAssignDialogButton ticket={item} />
          </CardContent>
        )}

        {/* messages section */}
        <MessagesSection />
      </Card>
    </DocumentLayout>
  );
});

export default TicketDetailItemPublic;
